import {
  Select as CarbonSelect,
  SelectItem,
  SelectItemGroup,
} from "@carbon/react";

export const View = (props) => {
  return (
    <div className="input-container">
      <CarbonSelect
        defaultValue={props.defaultValue} // "placeholder-item"
        helperText={props.helperText}
        id={props.id}
        invalidText={props.invalidText}
        labelText={props.label}
        {...props}
        className={`${props.className} switchapp-themed`}
      >
        <SelectItem text="Choose an option" value="placeholder-item" />
        <SelectItemGroup label="Category 1">
          <SelectItem text="Option 1" value="option-1" />
          <SelectItem text="Option 2" value="option-2" />
        </SelectItemGroup>
        <SelectItemGroup label="Category 2">
          <SelectItem text="Option 3" value="option-3" />
          <SelectItem text="Option 4" value="option-4" />
        </SelectItemGroup>
      </CarbonSelect>
    </div>
  );
};
